<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.customerContactTypes.addNewCustomerContactType') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/typy-kontaktow-z-klientem')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>

        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('settings.customerContactTypes.addNewCustomerContactType') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="customer-contact-type-new-form" tag="form">
              <div class="form-group">
                <label for="name">
                  {{ $t('settings.customerContactTypes.name') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="type">
                  {{ $t('settings.customerContactTypes.type') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="type"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="type" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.customerContactTypes.icon') }}:
                </label>
                <file-input
                  :onChange="setIcon"
                  id="inputFileIcon" />
              </div>
            </validation-observer>
          </d-tab>

          <d-tab :title="$t('settings.customerContactTypes.translations')">
            <p class="text-center">
              {{ $t('settings.customerContactTypes.addingTranslationsAvailableAfterSave') }}
            </p>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-contact-type-new',
  data () {
    return {
      icon: '',
      name: '',
      type: ''
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['customer-contact-type-new-form'], this.submitForm);
    },
    setIcon (event) {
      this.icon = event.target.files[0];
    },
    submitForm () {
      let imageFields = false;

      if (this.icon) {
        imageFields = ['icon'];
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customer-contact-types/store',
        formData: {
          icon: this.icon,
          name: this.name,
          type: this.type
        },
        successTitle: this.$t('settings.customerContactTypes.addCustomerContactTypeSuccessTitle'),
        successText: this.$t('settings.customerContactTypes.addCustomerContactTypeSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.customerContactTypes.addCustomerContactTypeErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/typy-kontaktow-z-klientem/')
        }
      }, imageFields);
    }
  }
};
</script>
